import React from "react";
import styles from "./Loading.module.scss";

/**
 * Ortak Yükleme (Loader) Bileşeni
 *
 * @param {boolean} fullScreen - Tüm ekranı kaplayan modal loader (örn: ilk giriş / yetkilendirme)
 * @param {string} text - Yükleme metni (opsiyonel)
 * @param {boolean} showBrand - BigPass logosu/markası gösterilsin mi? (varsayılan: true)
 * @param {string} className - Ek CSS sınıfı
 */
export default function Loading({
  fullScreen = false,
  text = "Yükleniyor...",
  showBrand = true,
  className = "",
}) {
  const containerClass = [
    styles["loading-container"],
    fullScreen
      ? styles["loading-container--fullscreen"]
      : styles["loading-container--content"],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClass} role="status" aria-live="polite">
      <div className={styles["loading-container__wrapper"]}>
        <div className={styles["loading-container__spinner-box"]}>
          <div className={styles["loading-container__ring"]} />
          <div className={styles["loading-container__ring-pulse"]} />
          <span className={styles["loading-container__logo"]}>BP</span>
        </div>

        {showBrand && (
          <div className={styles["loading-container__brand"]}>
            {"BIGPASS".split("").map((letter, i) => (
              <span
                key={i}
                style={{
                  animationDelay: `${i * 0.12}s`,
                }}
              >
                {letter}
              </span>
            ))}
          </div>
        )}

        {text && <p className={styles["loading-container__text"]}>{text}</p>}
      </div>
    </div>
  );
}
